import BaseObjectStore from './base-object.store';

class ExerciseStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'exercise';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new ExerciseStore();
